// Images slider
import Swiper from "swiper";

import "swiper/swiper-bundle.css";

$(window).on('load', () => {
    new Swiper(".image-slider", {
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: ".image-slider-button-next",
            prevEl: ".image-slider-button-prev",
        },
        loop: true
    });
});
